import React from "react";
import { Product } from "~/common/Store/models/ProductListing";
import { cls } from "cls";
interface ViewReplacementButtonProps {
  product: Product;
  isCompareWithProductBox?: boolean;
  productListingView?: string;
  undoBtnContainerStyle?: boolean;
}
export default function ViewReplacementButton({
  product,
  isCompareWithProductBox,
  productListingView,
  undoBtnContainerStyle
}: ViewReplacementButtonProps) {
  return <div className={cls("cartAndQuantity", undoBtnContainerStyle && productListingView === "grid" && "-ml-[30px]", isCompareWithProductBox && "text-left")} data-sentry-component="ViewReplacementButton" data-sentry-source-file="ViewReplacementButton.tsx">
      <a href={product.productReplacement ? product.productReplacement.replacementLink : ""}>
        <button type="button" className="btn btn-info btn-small btn-replace" data-testid="replacementBtn">
          View Replacement
        </button>
      </a>
    </div>;
}